export default class Modal {
	constructor($module) {
		this.$module = $module;

		if (Modal._bound) {
			return;
		}
		Modal._bound = true;

		const $openButtons = document.querySelectorAll("[data-modal-open]");
		for (let i = 0; i < $openButtons.length; i++) {
			$openButtons[i].addEventListener("click", (event) => {
				const modalId = event.currentTarget.getAttribute("data-modal-open");
				this.openModal(modalId);
			});
		}

		const $closeButtons = document.querySelectorAll("[data-modal-close]");
		for (let i = 0; i < $closeButtons.length; i++) {
			$closeButtons[i].addEventListener("click", (event) => {
				const modalId = event.currentTarget.getAttribute("data-modal-close");
				this.closeModal(modalId);
			});
		}
	}

	openModal(modalId) {
		const $modal = document.getElementById("bc-modal-" + modalId);
		if (!$modal) {
			return;
		}

		$modal.classList.add("bc-modal--open");
		this.lockPageScroll();
	}

	closeModal(modalId) {
		const $modal = document.getElementById("bc-modal-" + modalId);
		if (!$modal) {
			return;
		}

		$modal.classList.remove("bc-modal--open");
		this.unlockPageScrollIfNoOpenModal();
	}

	lockPageScroll() {
		if (Modal._scrollLocked) {
			return;
		}

		Modal._scrollTop = window.scrollY || window.pageYOffset || 0;
		document.body.classList.add("bc-modal-open");
		document.body.style.position = "fixed";
		document.body.style.top = "-" + Modal._scrollTop + "px";
		document.body.style.left = "0";
		document.body.style.right = "0";
		document.body.style.width = "100%";
		Modal._scrollLocked = true;
	}

	unlockPageScrollIfNoOpenModal() {
		const $openModal = document.querySelector(".bc-modal.bc-modal--open");
		if ($openModal) {
			return;
		}

		this.unlockPageScroll();
	}

	unlockPageScroll() {
		if (!Modal._scrollLocked) {
			return;
		}

		const scrollTop = Math.abs(parseInt(document.body.style.top || "0", 10));
		document.body.classList.remove("bc-modal-open");
		document.body.style.position = "";
		document.body.style.top = "";
		document.body.style.left = "";
		document.body.style.right = "";
		document.body.style.width = "";
		window.scrollTo(0, scrollTop || Modal._scrollTop || 0);
		Modal._scrollLocked = false;
		Modal._scrollTop = 0;
	}
}

Modal._bound = false;
Modal._scrollLocked = false;
Modal._scrollTop = 0;
